import { IFamilyMember } from '@/common/integrations/menhir/employee/employee/employee.types';
import { TOrderCategorySlug } from '@/common/integrations/menhir/employee/orders/orders.types';
import {
  getReimbursableItems,
  getReimbursementBeneficiaries,
} from '@/common/integrations/menhir/employee/reimbursements/reimbursements.service';
import { IReimbursableItem } from '@/common/integrations/menhir/employee/reimbursements/reimbursements.types';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

export const useGetReimbursementBeneficiaries = (
  category: TOrderCategorySlug,
  options?: UseQueryOptions<IFamilyMember[]>
) => {
  const { data: beneficiaries, ...rest } = useQuery({
    queryKey: [
      MENHIR_ENDPOINTS.EMPLOYEE.REIMBURSEMENTS.BENEFICIARIES,
      category,
    ],
    queryFn: () => getReimbursementBeneficiaries(category),
    ...options,
  });
  return { beneficiaries, ...rest };
};

export const useGetReimbursableItems = (
  category?: TOrderCategorySlug,
  options?: UseQueryOptions<IReimbursableItem[]>
) => {
  const { data: reimbursableItems, ...rest } = useQuery({
    queryKey: [
      MENHIR_ENDPOINTS.EMPLOYEE.REIMBURSEMENTS.REIMBURSABLE_ITEMS,
      category,
    ],
    queryFn: () => getReimbursableItems(category),
    ...options,
  });
  return { reimbursableItems, ...rest };
};
